import { Container, Typography, Box, Link, Button } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import Header from "../components/common/Header";
import OtpInput from "react-otp-input";
import IntroCard from "../components/Cards/IntroCard";
import SubmitButton from "../components/common/SubmitButton";
import { useNavigate, useLocation } from "react-router-dom";
import Backdrop from "../components/common/Backdrop";
import LoadingDots from "../components/Lottie/LoadingDots";
import Config from "../Config";
import { apis } from "../services/apiService";
import ContainerWithLogo from "./ContainerWithLogo";
import TextsmsOutlinedIcon from "@mui/icons-material/TextsmsOutlined";

import {
  constant,
  encryptData,
  login,
  randomAlphaNumeric,
  updateLocalStorageObj,
} from "../utils/utils";
import useSelector from "../store/selector";
import { CONSTANTS } from "../utils/constant";
import Captcha from "../components/common/Captcha";
import { encryptApiData } from "../utils/apiEncryption";
const OTPPay = ({ source }) => {
  const { setRecoilVal, getRecoilVal } = useSelector();
  let location = useLocation();
  let mn = location.state.mn;
  let em = location.state.em;
  let isEmail = location.state.isEmail;
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  const [otp, setOTP] = useState();
  const [error, setError] = useState("");
  const [reError, setreError] = useState(false);
  const [reDirect, setRedirect] = useState(false);
  const [counter, setCounter] = useState(10);
  const [resedCounter, setResedCounter] = useState(CONSTANTS.resendOTPTimer);
  const [resendDisabled, setResendDisabled] = useState(false);
  const [disabled, setDisabled] = useState(true);
  const [attempt, setAttempt] = useState(0);
  const [captchaMatched, setCaptchaMatched] = useState(false);
  const [randomCaptachData, setRandomCaptachData] = useState("");
  const [captchaData, setCaptchaData] = useState("");
  const [captchaError, setCaptchaError] = useState("");

  const timerRef = useRef(null);
  const resendTimeRef = useRef(null);

  let st =
    "A five digit code is sent to this " +
    (isEmail
      ? "email id " + em.substring(0, 4) + "XXXXXXXXX"
      : "mobile no. XXXXXX" + mn.substring(6)) +
    (source === "f" ? " for documents verification" : "");
  let apicontroller = isEmail ? "EOTP" : "OTP";
  let rLink = isEmail ? t("Resend via Email") : t("Resend via SMS");
  const handleChange = (otp) => {
    setOTP(otp);
    if (otp.length === 5) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  };
  let errors = {
    1: t("Invalid OTP. You have 2 attempts left."),
    2: t("Invalid OTP. This is your last attempt."),
    3: t(
      "Invalid OTP. You have no more attempts left. Please re-enter the correct mobile number."
    ),
  };
  let ResendOTP = async (e) => {
    try {
      clearInterval(resendTimeRef.current);
      setLoading(true);
      const reqData = {
        mn: mn,
      };
      let resp = await apis.postApi(Config.RepaymentUrl + "OTP/SendOTP", {
        request: encryptApiData(reqData),
      });
      if (resp.status === 200) {
        // setAttempt(attempt + 1);
        setOTP("");
        setError(false);
        setreError(true);
        setDisabled(false);
        setResedCounter(CONSTANTS.resendOTPTimer);
        resendTimeRef.current = setInterval(() => {
          setResedCounter((resedCounter) => resedCounter - 1);
        }, CONSTANTS.otpPayInterval.INTERVALTIMER);
        setResendDisabled(true);
      }
      setLoading(false);
    } catch (error) {
      const errorResult = JSON.parse(error?.message);
      setError(errorResult?.statusMessage);
      setLoading(false);
    } finally {
      setRandomCaptachData(randomAlphaNumeric);
      setCaptchaMatched(false);
      setCaptchaData("");
    }
  };

  let handleSubmit = async (e) => {
    e.preventDefault();
    setCaptchaError("");
    if (validateCaptchaFun()) {
      setreError(false);
      setDisabled(true);
      try {
        setLoading(true);
        const reqData = {
          mn: mn,
          otp: otp,
          em: em,
          ty: source,
        };
        let resp = await apis.postApi(Config.RepaymentUrl + "OTP/VerifyOTP", {
          request: encryptApiData(reqData),
        });
        let result = await resp.json();
        if (resp?.status === 200) {
          setLoading(false);
          clearInterval(resendTimeRef.current);
          if (source === "p") {
            setRecoilVal(
              constant.atomsName.USER_DETAIL,
              await login({
                screen: "pay",
                anchor: location.state.anchor,
                program: location.state.program,
                source: location.state.source,
                authToken: result?.data?.token,
              })
            );
            let data = { mn: mn, a: result?.data };
            navigate("/repayment" + location.state.LMS, { state: data });
            // login({
            //   screen: "pay",
            //   anchor: location.state.anchor,
            //   program: location.state.program,
            //   source: location.state.source,
            // });
          } else if (source === "f") {
            let data = { AppId: location.state.AppId };
            navigate("/complete-kyc", { state: data });
          } else {
            let data = { AppId: location.state.AppId };
            navigate("/complete-kyc", { state: data });
          }
        }
      } catch (error) {
        setLoading(false);
        const errorResult = JSON.parse(error?.message);
        setDisabled(false);
        setAttempt(attempt + 1);
        setError(errorResult?.statusMessage);
        if (
          errorResult?.statusMessage ===
          "You Have Exceed the Limit of verifying OTP."
        ) {
          setDisabled(true);
          setRedirect(true);
          timerRef.current = setInterval(() => {
            setCounter((counter) => counter - 1);
            // console.log("calling");
          }, CONSTANTS.otpPayInterval.INTERVALTIMER);
          setResedCounter(CONSTANTS.resendOTPTimer);
          clearInterval(resendTimeRef.current);
        } else if (
          errorResult?.statusMessage ===
          "Your Old OTP is Expired. We have send the new OTP to your registered Mobile Number."
        )
          setDisabled(false);
        setResedCounter(CONSTANTS.resendOTPTimer);
        setRandomCaptachData(randomAlphaNumeric);
        setCaptchaMatched(false);
        setCaptchaData("");
      }
    }
  };

  const handleRedirect = async () => {
    clearInterval(timerRef.current);
    // console.log("clear Interval")

    // localStorage.setItem("blockerPay", new Date().toString());
    const blockerData = getRecoilVal(constant?.atomsName?.USER_BLOCKER);
    const objData = {
      storageName: "blocker",
      mobile: await encryptData(
        `${location.state.mn}|${location.state.source}|${location.state.anchor}|${location.state.program}`.toString()
      ),
      currTime: new Date(),
      operation: "update",
      data: blockerData,
    };
    // await updateLocalStorageObj(objData);
    setRecoilVal(
      constant?.atomsName?.USER_BLOCKER,
      await updateLocalStorageObj(objData)
    );
    navigate(
      `/pay/${location.state.source}/${location.state.anchor}/${location.state.program}`
    );
  };

  useEffect(() => {
    setOTP("");
    setError(false);
    // setreError(true);
    // setDisabled(false);
    setResedCounter(CONSTANTS.resendOTPTimer);
    resendTimeRef.current = setInterval(() => {
      setResedCounter((resedCounter) => resedCounter - 1);
    }, CONSTANTS.otpPayInterval.INTERVALTIMER);
    if (resedCounter === 0) {
      clearInterval(resendTimeRef.current);
    }
    if (counter === 0) {
      clearInterval(timerRef.current);
    }
    setResendDisabled(true);
    setRandomCaptachData(randomAlphaNumeric);
  }, []);

  const validateCaptchaFun = () => {
    if (source === "f") {
      return true;
    }
    if (!captchaData) {
      setCaptchaError("Enter Captcha");
      return false;
    }
    if (!captchaMatched) {
      setCaptchaError("InValid Captcha");
      setRandomCaptachData(randomAlphaNumeric);
      setCaptchaMatched(false);
      return false;
    }
    return true;
  };

  useEffect(() => {
    // console.log(counter)

    async function fun() {
      if (counter === 0) {
        // console.log("counter 1 and redirect and clear interval")
        // localStorage.setItem("blockerPay", new Date().toString());
        const blockerData = getRecoilVal(constant?.atomsName?.USER_BLOCKER);
        const objData = {
          storageName: "blocker",
          mobile: await encryptData(
            `${location.state.mn}|${location.state.source}|${location.state.anchor}|${location.state.program}`.toString()
          ),
          currTime: new Date(),
          operation: "update",
          data: blockerData,
        };
        // await updateLocalStorageObj(objData);
        setRecoilVal(
          constant?.atomsName?.USER_BLOCKER,
          await updateLocalStorageObj(objData)
        );
        navigate(
          `/pay/${location.state.source}/${location.state.anchor}/${location.state.program}`
        );
        clearInterval(timerRef.current);
      }
      if (resedCounter === 0) {
        clearInterval(resendTimeRef.current);
        setResendDisabled(false);
      }
    }

    fun();
  }, [counter, resedCounter]);

  return (
    <>
      <ContainerWithLogo>
        {/* <ContainerForm
          component="form"
          onSubmit={handleSubmit}
          id="frmOTP"
          title="OTP"
          subtitle={st}
          icon={"/assets/OTP.svg"}
          showHeader={false}
        > */}

        <Box
          component="form"
          sx={{
            // p: "2px 2px",
            // mb: "10px",
            // top: "46%",
            // mt: "530px",
            marginTop: "310px",
            display: "flex",
            flexDirection: "column",
            // bottom: "8%",
            alignItems: "center",
            // boxShadow: "inset 0 0 5px #585858",
            // width: 400,
            bgcolor: "#e9e9e9",
            position: "absolute",
            backgroundColor: "#29417c",
          }}
        >
          <Box>
            <div>
              <OtpInput
                value={otp}
                onChange={handleChange}
                numInputs={5}
                inputType="tel"
                containerStyle="otpContainer"
                renderInput={(props) => <input {...props} />}
                inputStyle={error ? "otpInput otpError" : "otpInput"}
                focusStyle="otpFocus"
              />
            </div>
            {error && (
              <Box mt={2} ml={1}>
                <Typography
                  variant="p"
                  color="subtitle"
                  className="errorMsg_Th"
                >
                  {error}
                </Typography>
              </Box>
            )}
            {reError && (
              <Typography
                variant="p"
                color="subtitle"
                sx={{ color: "#D9416C" }}
              >
                Otp send to{" "}
                {isEmail
                  ? "email id " + em.substring(0, 4) + "XXXXXXXXX"
                  : "mobile no. XXXXXX" + mn.substring(6)}{" "}
                successfully. Please resend again in case you haven't received
                the OTP
              </Typography>
            )}

            {reDirect ? (
              <Box
                mt={2}
                mb={1}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  color: "#222AE0",
                  fontWeight: "500",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                  }}
                >
                  <Typography
                    variant="p"
                    color="info"
                    sx={{ fontWeight: "500", ml: 1 }}
                  >
                    You will redirect in {counter} Sec or{" "}
                    {/* You will redirect in {<p ref={count}>10</p>} Sec or{" "} */}
                    <Link onClick={handleRedirect}>click here</Link>
                  </Typography>
                </Box>
              </Box>
            ) : (
              <Box
                mt={2}
                mb={1}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  color: "#222AE0",
                  fontWeight: "500",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                  }}
                >
                  {resendDisabled === true ? (
                    <Typography
                      variant="p"
                      color="info"
                      sx={{
                        fontWeight: "500",
                        ml: 1,
                        color: "#a2a2a2",
                      }}
                    >
                      You can resend otp after {resedCounter} second
                    </Typography>
                  ) : (
                    <>
                      {/* <img src="/assets/message.svg" alt="message" /> */}
                      <TextsmsOutlinedIcon sx={{ color: "#a2a2a2" }} />
                      <Link onClick={ResendOTP}>
                        <Typography
                          variant="p"
                          color="info"
                          sx={{
                            fontWeight: "500",
                            ml: 1,
                            color: "#a2a2a2",
                          }}
                        >
                          {rLink}
                        </Typography>
                      </Link>
                    </>
                  )}
                </Box>
              </Box>
            )}
          </Box>
        </Box>
        <Box
          className="borderColor"
          sx={{
            borderRadius: "10px",
            p: "5px",
            display: source === "f" && "none",
            position: "absolute",
            top: "78%",
          }}
        >
          <Captcha
            captchaMatched={captchaMatched}
            setCaptchaMatched={setCaptchaMatched}
            randomCaptachData={randomCaptachData}
            setRandomCaptachData={setRandomCaptachData}
            setCaptchaData={setCaptchaData}
            captchaData={captchaData}
          />

          {captchaError && (
            <Box mt={1} ml={0}>
              <Typography variant="p" color="subtitle" className="errorMsg_Th">
                {captchaError}
              </Typography>
            </Box>
          )}
        </Box>
        {loading && (
          <Backdrop ax="center">
            <LoadingDots />
          </Backdrop>
        )}
        <Box
          // onSubmit={handleSubmit}
          sx={{ position: "absolute", bottom: "5%" }}
        >
          <Link onClick={handleSubmit}>
            <Button
              // variant="contained"
              // sx={{
              size="small"
              variant="contained"
              sx={{
                // borderRadius: 2,
                // mt: 1,
                // bgcolor: "#a6ce39",

                borderRadius: "1",
                mt: 1,
                bgcolor: "#a6ce39",
                borderRadius: 3,
                bgcolor: "#a6ce39",
                width: "200px",
              }}
            >
              Continue
            </Button>
          </Link>
          {/* <ContainerSubmitButton disabled={disabled} onSubmit={handleSubmit} /> */}
        </Box>
      </ContainerWithLogo>
    </>
  );
};
export default OTPPay;
